import { render, staticRenderFns } from "./integralDetails.vue?vue&type=template&id=4577d02c&scoped=true"
import script from "./integralDetails.vue?vue&type=script&lang=js"
export * from "./integralDetails.vue?vue&type=script&lang=js"
import style0 from "./integralDetails.vue?vue&type=style&index=0&id=4577d02c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4577d02c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4577d02c')) {
      api.createRecord('4577d02c', component.options)
    } else {
      api.reload('4577d02c', component.options)
    }
    module.hot.accept("./integralDetails.vue?vue&type=template&id=4577d02c&scoped=true", function () {
      api.rerender('4577d02c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/integralDetails.vue"
export default component.exports